
import { defineComponent } from "vue";
import CardCareer from "~/vue/molecules/cards/CardCareer.vue";
import CardEvent from "~/vue/molecules/cards/CardEvent.vue";
import CardFeatured from "~/vue/molecules/cards/CardFeatured.vue";
import CardKnowledgeHub from "~/vue/molecules/cards/CardKnowledgeHub.vue";

export default defineComponent({
	components: {
		"card--career": CardCareer,
		"card--event": CardEvent,
		"card--featured": CardFeatured,
		"card--knowledge-hub": CardKnowledgeHub,
	},
});
